import Button from "./Button";
import { LiaEnvelopeSolid, LiaMapMarkerAltSolid, LiaTtySolid } from "react-icons/lia";
export default function Footer(){
    return (
        <div class="container">
            <div  className="content">
                <div class="call-to-action-text">
                    <h2>Ready to enhance your railway infrastructure?</h2>
                    <p>Contact us today to discuss your project needs.</p>
                    <Button btnUrl="/contact" btnName="Contact Us"/>
                </div>

                <div className="address-contact">
                    <ul>
                        <li><h2>Our Contacts</h2></li>
                        <li> <LiaMapMarkerAltSolid /> Address: 104 Palliser Rd, Eastleigh, Edenvale, 1609</li>
                        <li> <LiaTtySolid /> Call: +27 (76) 108 3763 </li>
                        <li><LiaEnvelopeSolid /> Email: info@infraworks.co.za</li>
                    </ul>
                </div>
            </div>

            <div className="copy-right">
                
                <p>© {new Date().getFullYear()}  InfraWorks Turnkey Projects | Designed by <a href="https://www.innonexis.tech/" style={{ color: 'black' }} >Innovation Nexis</a></p>
            </div>
        </div>
    );
}
